import { render, staticRenderFns } from "./CascadeAccessView.vue?vue&type=template&id=52e65b11"
import script from "./CascadeAccessView.vue?vue&type=script&lang=js"
export * from "./CascadeAccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports